import { useProject } from 'src/services/project';

export function useProjectLink(): string {
  const { project } = useProject();

  return project ? `/projects/${project.id}` : '';
}
